import { Component, computed, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { TelephoneLinkComponent } from '../../../../shared/components/telephone-link/telephone-link.component';
import { OrbitFormClaimService } from '../../book-claim/services/orbit-form-claim.service';
import { AppInfo } from '../../../../global/environment';

@Component({
  selector: 'app-no-engineer-available',
  imports: [ButtonComponent, TelephoneLinkComponent],
  templateUrl: './no-engineer-available.component.html',
  styleUrl: './no-engineer-available.component.scss',
})
export class NoEngineerAvailableComponent implements OnInit {
  private readonly bookingOEMPhoneNumbers: Record<string, string> = {
    BAXI: '0344 335 6556',
    // WHP
    WHIRLPOOL: '0344 822 7227',
    BEKO: '0344 822 7227',
    // Haier brands
    HAIER: '0344 499 5599',
    'HOOVER CANDY': '0344 499 5599',
    HOOVER: '0344 499 5599',
    CANDY: '0344 499 5599',
  };

  planNumber = signal<string | undefined>(undefined);

  protected viewModel = computed(() => {
    const bookingOEM = this.orbitFormClaimService.state.claimData?.mandatoryData?.bookingOEM;
    const brand = this.orbitFormClaimService.state.claimData?.bundle?.manufacturer;

    const mappedPhoneNumber =
      this.bookingOEMPhoneNumbers[(bookingOEM ?? '').toUpperCase()] ??
      this.bookingOEMPhoneNumbers[(brand ?? '').toUpperCase()];

    const errorSource = this.orbitFormClaimService.noAvailabilitySource() ?? 'GetServiceOption';

    return {
      phoneNumber: mappedPhoneNumber ?? '0333 000 9703',
      repairsPageUrl: `${AppInfo.Environment.claimsURL}/my-plans/${this.planNumber()}/claims`,
      errorSource,
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(
    private readonly route: ActivatedRoute,
    private readonly orbitFormClaimService: OrbitFormClaimService
  ) {}

  ngOnInit(): void {
    this.planNumber.set(this.route.snapshot.params['planNumber']);
  }
}
